/** Virtual bundle id; installing it expands into the Cash Books standalone apps. */
export const NON_VAT_BOOKS_APP_ID = 'non-vat-books';
/** Virtual bundle id; Cash Books standalone apps plus bills and invoices. */
export const NON_VAT_ACCRUAL_BOOKS_APP_ID = 'non-vat-accrual-books';

export const CASH_RECEIPTS_JOURNAL_APP_ID = 'cash-receipts-journal';
export const CASH_DISBURSEMENTS_JOURNAL_APP_ID = 'cash-disbursements-journal';
/** Standalone General Journal (custom entries / all transactions). */
export const CUSTOM_ENTRIES_APP_ID = 'custom-entries';
export const GENERAL_LEDGER_APP_ID = 'general-ledger';
export const CHART_OF_ACCOUNTS_APP_ID = 'chart-of-accounts';
export const CUSTOMERS_APP_ID = 'customers';
export const SUPPLIERS_APP_ID = 'suppliers';
export const UPLOAD_ENTRY_APP_ID = 'upload-entry';
export const ACTIVITY_LOGS_APP_ID = 'activity-logs';
export const FINANCIAL_STATEMENTS_APP_ID = 'financial-statements';
export const LEDGER_REPORTS_APP_ID = 'ledger-reports';
export const PPE_APP_ID = 'ppe';
export const CAPITALS_APP_ID = 'capitals';
export const BILLS_APP_ID = 'bills';
export const INVOICES_APP_ID = 'invoices';

export const CASH_BOOKS_BUNDLE_APP_IDS = [
  CASH_RECEIPTS_JOURNAL_APP_ID,
  CASH_DISBURSEMENTS_JOURNAL_APP_ID,
  CUSTOM_ENTRIES_APP_ID,
  GENERAL_LEDGER_APP_ID,
  CHART_OF_ACCOUNTS_APP_ID,
  CUSTOMERS_APP_ID,
  SUPPLIERS_APP_ID,
  UPLOAD_ENTRY_APP_ID,
  ACTIVITY_LOGS_APP_ID,
  FINANCIAL_STATEMENTS_APP_ID,
  LEDGER_REPORTS_APP_ID,
  PPE_APP_ID,
  CAPITALS_APP_ID,
] as const;

export const ACCRUAL_BOOKS_BUNDLE_APP_IDS = [
  ...CASH_BOOKS_BUNDLE_APP_IDS,
  BILLS_APP_ID,
  INVOICES_APP_ID,
] as const;

export const BOOKS_BUNDLE_CONTENTS = {
  [NON_VAT_BOOKS_APP_ID]: CASH_BOOKS_BUNDLE_APP_IDS,
  [NON_VAT_ACCRUAL_BOOKS_APP_ID]: ACCRUAL_BOOKS_BUNDLE_APP_IDS,
} as const;

export type BooksBundleAppId = keyof typeof BOOKS_BUNDLE_CONTENTS;

export function isBooksBundleAppId(appId: string): appId is BooksBundleAppId {
  return Object.hasOwn(BOOKS_BUNDLE_CONTENTS, appId);
}

export function getBooksBundleInstallState(
  appId: BooksBundleAppId,
  installedAppIds: readonly string[],
): 'not-installed' | 'customized' | 'installed' {
  const installedSet = new Set(installedAppIds);
  const installedCount = BOOKS_BUNDLE_CONTENTS[appId].filter((childAppId) =>
    installedSet.has(childAppId),
  ).length;
  if (installedCount === 0) {
    return 'not-installed';
  }
  return installedCount === BOOKS_BUNDLE_CONTENTS[appId].length
    ? 'installed'
    : 'customized';
}

export type CatalogAppInstallState =
  'not-installed' | 'customized' | 'installed';

export function getCatalogAppInstallState(
  appId: string,
  installedAppIds: readonly string[],
): CatalogAppInstallState {
  if (isBooksBundleAppId(appId)) {
    return getBooksBundleInstallState(appId, installedAppIds);
  }
  return installedAppIds.includes(appId) ? 'installed' : 'not-installed';
}
